import { PersonaConfig, PersonaOrder, OrderStatus } from "../types";

// Nova Money — Meera's crew. Generated from the seeded Supabase project
// (rjcngcgusigkxijndlmg, nfx_* tables) so the picker and the agent always agree: if a
// number here disagrees with what the agent says on the call, that is a real finding.
// The demo beat is the SEGMENT — Prime / Plus / Basic get materially different promises
// for the same disputed charge: same-day, two-day, or seven-to-ten-day provisional credit.
export interface NovaCustomer {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  loyaltyTier: string;
  crmNotes: string;
  ordersCount: number;
  demoScenario?: string;
  orders: {
    orderId: string;
    product: string;
    /** Mapped onto the shared OrderStatus union for colour/tone only. */
    status: string;
    /** The honest words. A loan is not "delivered". */
    statusLabel?: string;
    date?: string;
  }[];
}

export const NOVA_CUSTOMERS: NovaCustomer[] = [
  {
    id: "NFX-C009",
    name: "Rohan Verma",
    firstName: "Rohan",
    lastName: "Verma",
    email: "rohan.verma@gmail.com",
    phone: "+91 99350 84469",
    loyaltyTier: "Basic",
    crmNotes: "Contrast-pair twin of NFX-C001 — identical TravelKart charge, Basic tier.",
    ordersCount: 2,
    demoScenario: "transaction_dispute",
    orders: [
      { orderId: "LN-4405", product: "consumer durable loan — ₹31,500 outstanding, EMI ₹4,590, 5 of 12 paid", status: "delivered", statusLabel: "Active", date: "2026-08-21" },
      { orderId: "CRD-10", product: "credit card ····5521 — ₹8,470 due", status: "delivered", statusLabel: "Active", date: "2026-08-20" },
    ],
  },
  {
    id: "NFX-C010",
    name: "Sneha Kulkarni",
    firstName: "Sneha",
    lastName: "Kulkarni",
    email: "sneha.kulkarni@gmail.com",
    phone: "+91 98600 27593",
    loyaltyTier: "Basic",
    crmNotes: "Contrast-pair twin of NFX-C002 — foreclosure with 4 percent fee.",
    ordersCount: 2,
    demoScenario: "foreclosure_quote",
    orders: [
      { orderId: "LN-4402", product: "personal loan — ₹192,000 outstanding, EMI ₹9,850, 13 of 36 paid", status: "delivered", statusLabel: "Active", date: "2026-08-20" },
      { orderId: "CRD-11", product: "debit card ····9912", status: "delivered", statusLabel: "Active", date: "" },
    ],
  },
  {
    id: "NFX-C011",
    name: "Deepak Chauhan",
    firstName: "Deepak",
    lastName: "Chauhan",
    email: "deepak.chauhan@gmail.com",
    phone: "+91 98290 55018",
    loyaltyTier: "Basic",
    crmNotes: "EMI bounced this cycle — insufficient balance; retry scheduled.",
    ordersCount: 2,
    demoScenario: "emi_missed_bounce",
    orders: [
      { orderId: "LN-4408", product: "two wheeler loan — ₹61,400 outstanding, EMI ₹3,960, 6 of 24 paid", status: "delivered", statusLabel: "Active", date: "2026-08-16" },
      { orderId: "CRD-12", product: "debit card ····4105", status: "delivered", statusLabel: "Active", date: "" },
    ],
  },
  {
    id: "NFX-C012",
    name: "Ritu Malhotra",
    firstName: "Ritu",
    lastName: "Malhotra",
    email: "ritu.malhotra@gmail.com",
    phone: "+91 98720 40961",
    loyaltyTier: "Basic",
    crmNotes: "Moved to a new flat; wants address updated on the account.",
    ordersCount: 1,
    demoScenario: "address_update",
    orders: [
      { orderId: "CRD-13", product: "credit card ····6084 — ₹6,240 due", status: "delivered", statusLabel: "Active", date: "2026-08-22" },
    ],
  },
  {
    id: "NFX-C005",
    name: "Farhan Sheikh",
    firstName: "Farhan",
    lastName: "Sheikh",
    email: "farhan.sheikh@gmail.com",
    phone: "+91 99490 63315",
    loyaltyTier: "Plus",
    crmNotes: "High card utilisation two months running; pre-assessed for limit increase.",
    ordersCount: 1,
    demoScenario: "card_limit_increase",
    orders: [
      { orderId: "CRD-06", product: "credit card ····8804 — ₹19,800 due", status: "delivered", statusLabel: "Active", date: "2026-08-25" },
    ],
  },
  {
    id: "NFX-C006",
    name: "Priya Nair",
    firstName: "Priya",
    lastName: "Nair",
    email: "priya.nair@gmail.com",
    phone: "+91 98470 92241",
    loyaltyTier: "Plus",
    crmNotes: "Reported failed UPI transfer via chat; money debited, reversal pending.",
    ordersCount: 2,
    demoScenario: "failed_transfer_upi",
    orders: [
      { orderId: "LN-4407", product: "consumer durable loan — ₹22,600 outstanding, EMI ₹5,720, 8 of 12 paid", status: "delivered", statusLabel: "Active", date: "2026-08-19" },
      { orderId: "CRD-07", product: "debit card ····6633", status: "delivered", statusLabel: "Active", date: "" },
    ],
  },
  {
    id: "NFX-C007",
    name: "Meghna Joshi",
    firstName: "Meghna",
    lastName: "Joshi",
    email: "meghna.joshi@gmail.com",
    phone: "+91 99090 18876",
    loyaltyTier: "Plus",
    crmNotes: "Waiting on a merchant refund; merchant claims already processed.",
    ordersCount: 1,
    demoScenario: "refund_not_received",
    orders: [
      { orderId: "CRD-08", product: "credit card ····2278 — ₹9,860 due", status: "delivered", statusLabel: "Active", date: "2026-08-19" },
    ],
  },
  {
    id: "NFX-C008",
    name: "Sanjay Gupta",
    firstName: "Sanjay",
    lastName: "Gupta",
    email: "sanjay.gupta@gmail.com",
    phone: "+91 98110 37742",
    loyaltyTier: "Plus",
    crmNotes: "New-ish customer; personal loan application awaiting bank statement.",
    ordersCount: 2,
    demoScenario: "loan_application_status",
    orders: [
      { orderId: "LN-4409", product: "personal loan — ₹0 outstanding, 0 of 42 paid", status: "in_transit", statusLabel: "Documents pending", date: "" },
      { orderId: "CRD-09", product: "debit card ····7745", status: "delivered", statusLabel: "Active", date: "" },
    ],
  },
  {
    id: "NFX-C001",
    name: "Ananya Rao",
    firstName: "Ananya",
    lastName: "Rao",
    email: "ananya.rao@gmail.com",
    phone: "+91 98450 21437",
    loyaltyTier: "Prime",
    crmNotes: "High-value customer; salaried; never missed an EMI.",
    ordersCount: 2,
    demoScenario: "transaction_dispute",
    orders: [
      { orderId: "LN-4404", product: "two wheeler loan — ₹41,200 outstanding, EMI ₹4,180, 13 of 24 paid", status: "delivered", statusLabel: "Active", date: "2026-08-17" },
      { orderId: "CRD-01", product: "credit card ····4417 — ₹38,470 due", status: "delivered", statusLabel: "Active", date: "2026-08-23" },
    ],
  },
  {
    id: "NFX-C002",
    name: "Arjun Iyer",
    firstName: "Arjun",
    lastName: "Iyer",
    email: "arjun.iyer@gmail.com",
    phone: "+91 98841 55210",
    loyaltyTier: "Prime",
    crmNotes: "Long relationship; considering early closure of personal loan.",
    ordersCount: 3,
    demoScenario: "foreclosure_quote",
    orders: [
      { orderId: "LN-4401", product: "personal loan — ₹284,500 outstanding, EMI ₹16,450, 15 of 36 paid", status: "delivered", statusLabel: "Active", date: "2026-08-18" },
      { orderId: "CRD-02", product: "credit card ····7702 — ₹22,150 due", status: "delivered", statusLabel: "Active", date: "2026-08-21" },
      { orderId: "CRD-14", product: "debit card ····1149", status: "in_transit", statusLabel: "Replacement in transit", date: "" },
    ],
  },
  {
    id: "NFX-C003",
    name: "Vikram Mehta",
    firstName: "Vikram",
    lastName: "Mehta",
    email: "vikram.mehta@gmail.com",
    phone: "+91 98200 78654",
    loyaltyTier: "Prime",
    crmNotes: "Frequent traveller; two cards; top-up pre-approved on personal loan.",
    ordersCount: 3,
    demoScenario: "card_lost_stolen",
    orders: [
      { orderId: "LN-4403", product: "personal loan — ₹421,000 outstanding, EMI ₹18,240, 11 of 48 paid", status: "delivered", statusLabel: "Active", date: "2026-08-15" },
      { orderId: "CRD-03", product: "credit card ····9046 — ₹41,200 due", status: "delivered", statusLabel: "Active", date: "2026-08-18" },
      { orderId: "CRD-04", product: "debit card ····3821", status: "delivered", statusLabel: "Active", date: "" },
    ],
  },
  {
    id: "NFX-C004",
    name: "Kavita Deshpande",
    firstName: "Kavita",
    lastName: "Deshpande",
    email: "kavita.deshpande@gmail.com",
    phone: "+91 98903 41128",
    loyaltyTier: "Prime",
    crmNotes: "Periodic KYC re-verification triggered; document expiring.",
    ordersCount: 2,
    demoScenario: "kyc_reverification",
    orders: [
      { orderId: "LN-4406", product: "personal loan — ₹112,700 outstanding, EMI ₹11,800, 12 of 24 paid", status: "delivered", statusLabel: "Active", date: "2026-08-14" },
      { orderId: "CRD-05", product: "credit card ····5590 — ₹17,650 due", status: "delivered", statusLabel: "Active", date: "2026-08-24" },
    ],
  },
];

export const NOVA_PERSONA_ID_PREFIX = "nfx_";

export function getNovaCustomer(id: string): NovaCustomer | undefined {
  return NOVA_CUSTOMERS.find((c) => c.id === id);
}

export function novaCustomerToPersona(c: NovaCustomer): PersonaConfig {
  return {
    id: `${NOVA_PERSONA_ID_PREFIX}${c.id}`,
    name: c.name,
    role: c.crmNotes || "Customer",
    avatarInitials: ((c.firstName[0] ?? "") + (c.lastName[0] ?? "")).toUpperCase(),
    avatarBg: "",
    tagLine: c.crmNotes,
    email: c.email,
    phone: c.phone,
    accountId: c.id,
    memberSince: "",
    loyaltyTier: c.loyaltyTier,
    orders: c.orders.map((o): PersonaOrder => ({
      orderId: o.orderId,
      product: o.product,
      status: o.status as OrderStatus,
      statusLabel: o.statusLabel,
      date: o.date ?? "",
    })),
    ordersCount: c.ordersCount,
    bestFor: [],
    suggestedQuestions: {},
    crmNotes: c.crmNotes,
  };
}
